/**
 * GradientGauge — the red→amber→green meter shown next to every score.
 *
 * Gradient hex stops match `BrandEquityVisualizationWrapper.tsx` exactly, so
 * the marketer view feels consistent with the rest of the dashboard. A dark
 * marker pin indicates the brand's current position on the -100..+100 scale.
 */

import React from 'react';
import { gaugePosition, METER_GRADIENT, METER_GRADIENT_NEGATIVE } from '../config/bandColours';

export interface GradientGaugeProps {
  value: number | null;
  /** Bar height in pixels. Smaller for drawer headers, larger for Q1. */
  height?: number;
  /** Hide the position marker (used decoratively in legends). */
  showMarker?: boolean;
  /** Price Deals: -100..0 scale with zero at the right edge. */
  negativeScale?: boolean;
}

export const GradientGauge: React.FunctionComponent<GradientGaugeProps> = ({
  value,
  height = 12,
  showMarker = true,
  negativeScale = false,
}) => (
  <div style={{ position: 'relative', width: '100%' }}>
    <div
      style={{
        height,
        borderRadius: height,
        background: negativeScale ? METER_GRADIENT_NEGATIVE : METER_GRADIENT,
      }}
    />
    {showMarker && value != null && (
      <div
        style={{
          position: 'absolute',
          top: -3,
          height: height + 6,
          width: 3,
          borderRadius: 3,
          background: '#0F172A',
          left: `calc(${
            negativeScale ? Math.max(0, Math.min(100, value + 100)) : gaugePosition(value)
          }% - 1.5px)`,
        }}
      />
    )}
  </div>
);
